(function () {
  function initMagnify(container) {
    if (container.dataset.napMagnifyInit) return;
    var img = container.querySelector('img.product-media__image');
    if (!img) return;
    container.dataset.napMagnifyInit = 'true';

    var lens = document.createElement('div');
    lens.className = 'nap-magnify-lens';
    container.appendChild(lens);
    var zoomFactor = 2.2;

    container.addEventListener('mousemove', function (e) {
      var rect = container.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      var lensSize = lens.offsetWidth || 160;
      lens.style.left = (x - lensSize / 2) + 'px';
      lens.style.top = (y - lensSize / 2) + 'px';
      lens.style.backgroundImage = "url('" + (img.currentSrc || img.src) + "')";
      lens.style.backgroundSize = (rect.width * zoomFactor) + 'px ' + (rect.height * zoomFactor) + 'px';
      var bgX = (x / rect.width) * rect.width * zoomFactor - lensSize / 2;
      var bgY = (y / rect.height) * rect.height * zoomFactor - lensSize / 2;
      lens.style.backgroundPosition = '-' + bgX + 'px -' + bgY + 'px';
      lens.classList.add('is-active');
    });
    container.addEventListener('mouseleave', function () {
      lens.classList.remove('is-active');
    });
  }

  function init() {
    document.querySelectorAll('.product-media-container--image').forEach(initMagnify);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  var observer = new MutationObserver(init);
  observer.observe(document.body, { childList: true, subtree: true });
})();
